<template>
    <div class="bto-sb-widget bto-sb-widget-category bto-sb-categorymatch-filtering">
        <div v-if="match.matchId" class="bto-sb-widget bto-sb-widget-prematch bto-sb-widget-prematch-full-view"
             :class="{'bto-sb-widget-livematch' : matchType === 'live', 'bto-sb-widget-category-dropdown' : changeEvent }">
            <div
                    v-if="matchType === 'live' && (useLiveTracker || hasLiveStream()) && match.betRadarId"
                    class="bto-sb-widget"
            >
                <livestream-component v-if="hasLiveStream() && !livePlayerFailed"
                  :streamId="match.streamId || lcoMatch.streamId"
                  :key="match.streamId || lcoMatch.streamId"
                  :providerId="match.brokerId || lcoMatch.integrationBrokerId"
                  @streamLoadError="livePlayerLoadError" />
                <live-tracker-component v-if="useLiveTracker && (!hasLiveStream() || livePlayerFailed) && match.betRadarId"
                                        :betRadarId="(+match.betRadarId)"
                                        :tournamentId="match.tournamentId"
                                        :tournamentName="match.tournamentName"
                                        :isAwayAtHome="match.awayAtHome"/>
                <inline-message v-if="livePlayerFailed" type="info" :message="t('Mobile.LiveStreamFailed')"/>
            </div>
          
            <!-- start - live title -->
            <div v-if="matchType === 'live'" class="bto-sb-widget-title bto-sb-widget-nav-icon "
              :class="{ 'bto-sb-open': openEvent, 'bto-sb-close': !openEvent }">
              <h3 v-if='match.homeTeam && match.guestTeam'>
                <a class="bto-sb-widget-title-dropdown">
                  {{`${match.homeTeam} ${t('Mobile.VS')} ${match.guestTeam}`}}
                  <span v-if="changeEvent" class="bto-sb-arrow" @click="openChangeEvents()"></span>
                </a>
              </h3>
              <EventSelect :match="match" v-if="changeEvent" :isOpen="openEvent" @openEvents="openChangeEvents" />
              <!-- <div v-show="changeEvent" class="bto-sb-select-dropdown bto-sb-scrollbar">
                <SelectEventList :match="match" />
              </div>  -->
              <p v-if="match.isLiveMatch">
                  {{match.tournamentName}}
              </p>
              <span
                      v-if="match.isLiveMatch && match.status"
                      class="bto-sb-livematch-time">
                {{`${match.status} / ${match.time}`}}
              </span>
            </div>
            <!-- end - live title -->
            <!-- start - prematch title -->
            <div v-if="matchType === 'prematch'" class="bto-sb-widget-title bto-sb-widget-nav-icon"
                :class="{ 'bto-sb-open': openEvent, 'bto-sb-close': !openEvent }">
                <h3 v-if='match.homeTeam && match.guestTeam'>
                  <a class="bto-sb-widget-title-dropdown">
                    {{`${match.homeTeam} ${t('Mobile.VS')} ${match.guestTeam}`}}
                    <span v-if="changeEvent" class="bto-sb-arrow" @click="openChangeEvents()"></span>
                  </a>
                  
                </h3>
                <ul class="bto-sb-widget-nav-icon">
                    <li>
                        <a href="#" @click.prevent="$router.go(-1)" :title="t('Public.Close')"
                           class="bto-sb-widget-nav-icon-close"></a>
                    </li>
                </ul>
                <EventSelect :match="match" v-if="changeEvent" :isOpen="openEvent" :preMatchEvents="preMatchEvents" @openEvents="openChangeEvents" /> 
            </div>
            <div v-if="matchType === 'prematch'" class="bto-sb-widget-title-small">
                <!-- <i :class="{'bto-app-cash': showCashoutTab === true && hasCashoutOdds }"></i> -->
                <span v-if="match.eventCode" class="bto-sb-categoryevent-code"><i>{{t('Public.code')}}</i><i>{{match.eventCode}}</i></span>
                <h4 v-if='match.categoryName && match.tournamentName'>
                    {{match.categoryName}} > {{match.tournamentName}}
                </h4>
                <span class="bto-sb-categoryevent-date">{{match.date}} {{match.time}}</span>
            </div>
            <!-- end - prematch title -->
            <!-- Zoom soccer component -->
            <zoom-soccer-component
              v-if="match.sportId === zoomSoccerId && match.betRadarId"
              :betRadarId="match.betRadarId"
              :tournamentName="match.tournamentName"
              :isLive="match.isLiveMatch" />
             <!-- Prematch statistic component -->  
            <prematch-tracker-component
              v-if="showStatistics && !match.isLiveMatch && match.betRadarId && match.feedProvider"
              :betRadarId="match.betRadarId"
              :feedProvider="match.feedProvider"
              :isAwayAtHome="match.awayAtHome" />
            <!------------------------------------- BOOSTED ODDS ---------------------------------------->
            <boosted-odd-widget 
              v-if="!match.isLiveMatch"
              :showSportFilter="false"
              :showTitle="false"
              :showTeamFlags="showTeamIcon"
              :embedded="true"
              :showEmpty="false" />
            <!------------------------------------- END BOOSTED ODDS ---------------------------------------->
            
            <div class="bto-sb-widget-content">
                <div class="bto-sb-event-mormarket">
                    <div class="bto-sb-mormarket-nav">
                        <div class="bto-sb-mormarket-filter">
                            <ul>
                                <li
                                        :class="{'bto-sb-mormarket-filter-active' : selectedMarket === null}"
                                >
                                    <a
                                            href="javascript:void(0);"
                                            title="All Markets"
                                            class="bto-sb-form-btn"
                                            @click="selectMarket(null)"
                                    >
                                        {{t('Mobile.AllMarkets')}}
                                    </a>
                                </li>
                                <li v-if="hasBetBuilder" :class="{'bto-sb-mormarket-filter-active' : selectedMarket === BB_TAB_ID}">
                                  <a
                                    href="javascript:void(0);"
                                    class="bto-sb-form-btn"
                                    @click="openBetBuilderOffer()"
                                  >
                                    {{t("BB.BetBuilder")}}
                                  </a>
                                </li>
                                <li
                                        v-for="(market, idx) in match.tabs.slice(0, numOfMarketsToSlice)"
                                        :key="idx"
                                        :class="{'bto-sb-mormarket-filter-active' : selectedMarket === market.id}"
                                >
                                    <a
                                            class="bto-sb-form-btn"
                                            href="javascript:void(0);"
                                            :title="market.name"
                                            @click="selectMarket(market.id)"
                                    >
                                        {{market.name}}
                                    </a>
                                </li>
                                <li :class="{'bto-sb-mormarket-filter-active' : selectedMarket === outrightsMarketId}"
                                    v-if="outrightsMarketId !== -10">
                                    <a title="Outrights"
                                       class="bto-sb-form-btn"
                                       @click="selectMarket(outrightsMarketId)">
                                        {{t('Mobile.Outrights')}}
                                    </a>
                                </li>
                                <li :class="{'bto-sb-mormarket-filter-active' : selectedMarket === 'player-markets'}"
                                  v-if="isPlayerTabVisible">
                                    <a :title="playerTab.name || t('Public.PlayerMarkets')"
                                        class="bto-sb-form-btn"
                                        @click="selectMarket('player-markets')">
                                        {{ playerTab.name || t('Public.PlayerMarkets') }}
                                    </a>
                                </li>
                                <li :class="{'bto-sb-mormarket-filter-active' : selectedMarketInDropdown()}">
                                    <div class="bto-sb-form-select">
                                        <select
                                                :disabled="match.tabs.length <= 3 && !playerOdds.length && !scorecast.odds.length && (showCashoutTab === true && !hasCashoutOdds)"
                                                @change="selectMarket($event.target.value)"
                                        >
                                            <option
                                                    selected
                                                    disabled
                                                    v-if="!selectedMarketInDropdown()"
                                            >
                                                {{t('Mobile.SelectMarket')}}
                                            </option>
                                            <option
                                                    v-for="(market, idx) in match.tabs.slice(numOfMarketsToSlice).filter(m=>m.id!==outrightsMarketId)"
                                                    :key="idx"
                                                    :value="market.id"
                                            >
                                                {{market.name}}
                                            </option>
                                            <option
                                                    v-if="playerOdds.length"
                                                    value="playerOdds"
                                            >
                                                {{t('Global.OddType.GoalScorers')}}
                                            </option>
                                            <option
                                                    v-if="scorecast.id && scorecast.odds.length"
                                                    value="scorecast"
                                            >
                                                {{t('Public.ScoreCast')}}
                                            </option>
                                            <option
                                                    v-if="showCashoutTab && hasCashoutOdds"
                                                    value="cashout"
                                            >
                                                {{t('Mobile.cashout')}}
                                            </option>
                                        </select>
                                        <div class="bto-sb-form-select-arrow"></div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bto-sb-mormarket-grid">
                            <a
                                    href="javascript:void(0);"
                                    :title="`${t('W.fView')}`"
                                    :class="{'bto-sb-mormarket-grid-active' : columns === 1}"
                                    @click="changeView(1)"
                            ></a>
                            <a
                                    href="javascript:void(0);"
                                    :title="`${t('W.gView')}`"
                                    :class="{'bto-sb-mormarket-grid-active' : columns === 2}"
                                    @click="changeView(2)"
                            ></a>
                        </div>
                    </div>
                    <div class="bto-sb-widget bto-sb-widget-title bto-support-legend"  v-if="showLegendBar && ((showCashoutTab && hasCashoutOdds)||hasBetBuilder)">
                      <span  v-if="showCashoutTab && hasCashoutOdds">
                        <i class="bto-app-cash"></i>
                        {{ t('Public.SupporCashout') }}
                      </span>
                      <span v-if="hasBetBuilder">
                        <i class="bto-app-betbuilder"></i>
                        {{ t('Public.SupporBetBuilder') }}
                      </span>
                    </div>
                    <!-- start - render tabs + markets -->
                    <div class="bto-sb-mormarket-content" :class="getViewClass()" ref="matchOddsContainer" data-bto-game-markets>
                        <template v-if="selectedMarket !== BB_TAB_ID">
                          <template v-for="(tab, tabIdx) in match.tabs">
                              <template
                                      v-if="selectedMarket === tab.id || selectedMarket === null || selectedMarket === 'cashout'">
                                  <template v-for="(odd, oddIdx) in selectedMarket === 'cashout' ?
                                    match.tabs[tabIdx].odds.filter(o => o.cashout === true) :
                                    match.tabs[tabIdx].odds
                                  ">
                                      <tab-market-component
                                              v-if="!(selectedMarket === null || selectedMarket === 'cashout') || !odd.isDuplicateMarket"
                                              :key="tabIdx * 1000 + oddIdx"
                                              :match="match"
                                              :tabIdx="tabIdx"
                                              :odd="odd"
                                              :oddIdx="oddIdx"
                                              :selectedMarket="selectedMarket"
                                              :isItDuplicateMarket="isItDuplicateMarket"
                                              :selectedTooltip="selectedTooltip"
                                              @toggleTooltip="toggleMarketTooltip"
                                      />
                                  </template>
                              </template>
                          </template>
                          <template v-if="selectedMarket === null || selectedMarket === 'player-markets'">
                            <player-markets-component :match="match" :groups="playerTab.groups || []" />
                            <player-markets-component :match="match" :groups="(match.playerMarketsTab && match.playerMarketsTab.groups) || []"/>
                          </template>
                        </template>
                        <inline-message
                          v-if="selectedMarket === BB_TAB_ID && hasBetBuilderMarkets"
                          :message="t('BB.MinimumTwoSelections')"
                          type="info"
                        />
                        <template v-if="selectedMarket === BB_TAB_ID && (sportCastFixtureId && hasBetBuilderMarkets)">
                          <BetBuilderTab v-for="(tab, key, idx) in betBuilderTabs" :key="key" :tab="tab" :tabIdx="idx" :fixture="betBuilderFixture" />
                        </template>
                        <template v-if="selectedMarket === BB_TAB_ID && (swishFixtureId && hasSwishBetBuilderMarkets)">
                          <SwishBetBuilderTab
                            v-for="(tab, key) in swishBetBuilderTabs.markets"
                            :key="key"
                            :tab="tab"
                            :fixture="betBuilderFixture" 
                            :match="match"
                            :matchInfo="swishBetBuilderTabs.matchInfo"/>
                        </template>
                        <!-- end - render tabs + markets -->
                        <outrights-tab-market v-if="showOutrights" :tab="outrightMarketTab"/>
                        <!-- start - player odds 'dropdowns' view tab -->
                        <div
                                v-if="playerOddsViewType === 'dropdowns' && playerOdds.length && (selectedMarket === 'playerOdds' || selectedMarket === null)"
                                class="bto-sb-event-mormarket-market"
                        >
                            <div class="bto-sb-event-mormarket-market-name bto-sb-bar-filter">
                                <h4>{{t('Global.OddType.GoalScorers')}}</h4>
                            </div>
                            <div class="bto-sb-event-mormarket-market-odd">
                <span>
                  <div class="bto-sb-form-select">
                    <select
                            v-model="selectedPlayer"
                    >
                      <option
                              selected
                              v-if="!selectedPlayer"
                              :value="undefined"
                      >
                        {{t('W.SelectPlayer')}}
                      </option>
                      <option
                              v-for="(playerName, idx) in distinctPlayers"
                              :key="idx"
                              :value="playerName"
                      >
                        {{playerName}}
                      </option>
                    </select>
                    <div class="bto-sb-form-select-arrow"></div>
                  </div>
                </span>
                                <span>
                  <div class="bto-sb-form-select">
                    <select
                            :disabled="!selectedPlayer"
                            v-model="selectedPlayerOddType"
                    >
                      <option
                              v-if="!selectedPlayerOddType"
                              :value="undefined"
                      >
                        {{t('W.SelectOddType')}}
                      </option>
                      <option
                              v-for="(oddType, idx) in selectedPlayer ? [
                          {
                            identifier: 'first',
                            name: t('Mobile.FirstGoalScorer'),
                          },
                          {
                            identifier: 'any',
                            name: t('Mobile.AnyGoalScorer'),
                          },
                          {
                            identifier: 'last',
                            name: t('Mobile.LastGoalscorer'),
                          }
                        ] : []"
                              :key="idx"
                              :value="oddType.identifier"
                      >
                        {{oddType.name}}
                      </option>
                    </select>
                    <div class="bto-sb-form-select-arrow"></div>
                  </div>
                </span>
                                <span>
                  <match-odd-component
                          v-if="selectedPlayer && selectedPlayerOddType"
                          :match="match"
                          :odd="{}"
                          :outcome="getSelectedPlayerOdd()"
                          :isDetails="true"
                  />
                  <match-odd-component
                          v-else
                          :match="match"
                          :odd="{}"
                          :outcome="{
                      id: 'N/A',
                      name: t('W.NA'),
                      originalDecimalOutcome: '--'
                    }"
                          :isDetails="true"
                  />
                </span>
                            </div>
                        </div>
                        <!-- end - player odds 'dropdowns' view tab -->
                        <div
                                v-if="scorecast.id && scorecast.odds.length && (selectedMarket === 'scorecast' || selectedMarket === null)"
                                class="bto-sb-event-mormarket-market"
                        >
                            <div class="bto-sb-event-mormarket-market-name">
                                <h4>{{t('Public.ScoreCast')}}</h4>
                            </div>
                            <div class="bto-sb-mormarket-nav">
                                <div class="bto-sb-mormarket-filter">
                                    <ul>
                                        <li
                                                v-for="(scorecastTab, idx) in scorecast.odds"
                                                :key="idx"
                                                :class="{'bto-sb-mormarket-filter-active': selectedScorecastTabIdx === idx}"
                                        >
                                            <a
                                                    href="javascript:void(0);"
                                                    class="bto-sb-form-btn"
                                                    @click="selectScorecastTab(idx)"
                                            >{{scorecastTab.marketName}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="bto-sb-event-mormarket-market-odd">
                <span>
                  <div class="bto-sb-form-select">
                    <select v-model="selectedScorecastPlayerIdx" @change="scorecastPlayerUpdated()">
                      <option v-if="selectedScorecastPlayerIdx === undefined" selected disabled :value="undefined">
                        {{t('W.SelectPlayer')}}
                      </option>
                      <option
                              v-for="(player, idx) in scorecast.odds[selectedScorecastTabIdx].players"
                              :key="idx"
                              :value="idx"
                      >
                        {{player.name}}
                      </option>
                    </select>
                    <div class="bto-sb-form-select-arrow"></div>
                  </div>
                </span>
                                <span>
                  <div
                          class="bto-sb-form-select"
                          :class="{'bto-sb-form-btn-disabled': selectedScorecastPlayerIdx === undefined}"
                  >
                    <select v-model="selectedScorecastPlayerOutcomeIdx">
                      <option v-if="selectedScorecastPlayerIdx === undefined" selected disabled
                              :value="undefined">--</option>
                      <template v-if="selectedScorecastPlayerIdx !== undefined">
                        <option selected disabled :value="undefined"
                                v-if="selectedScorecastPlayerOutcomeIdx === undefined">
                          {{t('W.SelectOdd')}}
                        </option>
                        <option
                                v-for="(odd, idx) in scorecast.odds[selectedScorecastTabIdx].players[selectedScorecastPlayerIdx].outcomes"
                                :key="idx"
                                :value="idx"
                        >
                          {{odd.name}} ({{odd.originalDecimalOutcome | formatOddDisplay($root.oddFormat)}})
                        </option>
                      </template>
                    </select>
                    <div class="bto-sb-form-select-arrow"></div>
                  </div>
                </span>
                                <span>
                  <match-odd-component
                          v-if="selectedScorecastPlayerIdx !== undefined && selectedScorecastPlayerOutcomeIdx !== undefined"
                          :match="match"
                          :odd="{
                      marketName: scorecast.odds[selectedScorecastTabIdx].players[selectedScorecastPlayerIdx].name
                    }"
                          :outcome="scorecast.odds[selectedScorecastTabIdx].players[selectedScorecastPlayerIdx].outcomes[selectedScorecastPlayerOutcomeIdx]"
                          :isDetails="true"
                  />
                  <match-odd-component
                          v-else
                          :match="match"
                          :odd="{}"
                          :outcome="{
                      id: 'N/A',
                      name: t('W.NA'),
                      originalDecimalOutcome: '--'
                    }"
                          :isDetails="true"
                  />
                </span>
                            </div>
                        </div>
                    </div>
                    <!-- start - player odds 'all' view tab -->
                    <div
                            v-if="playerOddsViewType === 'all' && playerOdds.length && (selectedMarket === 'playerOdds' || selectedMarket === null)"
                            class="bto-sb-widget-content bto-sb-event-mormarket-full bto-sb-event-market-player"
                    >
                        <div class="bto-sb-event-odds-nav">
                            <div class="bto-sb-event-odds-nav-labels">
                                <div class="bto-sb-event-odds-left">
                                    <div class="bto-sb-event-odds-cell bto-sb-event-eventlabel">
                                        {{t('Global.OddType.GoalScorers')}}
                                    </div>
                                </div>
                                <div class="bto-sb-event-odds-right">
                                    <div class="bto-sb-event-odds-cell">
                                        <span class="bto-sb-event-marketlabel">{{t('Mobile.FirstGoalScorer')}}</span>
                                        <span class="bto-sb-event-marketlabel">{{t('Mobile.AnyGoalScorer')}}</span>
                                        <span class="bto-sb-event-marketlabel">{{t('Mobile.LastGoalscorer')}}</span>
                                        <!-- <span class="bto-sb-event-marketlabel">{{t('PlayerOddType.HatTrick')}}</span>
                                        <span class="bto-sb-event-marketlabel">{{t('PlayerOddType.TwoOrMoreGoals')}}</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bto-sb-event-odds-content">
                            <div
                                    v-for="(player, idx) in playerOdds"
                                    :key="idx"
                                    class="bto-sb-event-odds"
                            >
                                <div class="bto-sb-event-odds-left">
                                    <div class="bto-sb-event-name">
                                        <a href="javascript:void(0);" title="Hallam Robert Hope">
                                            <div class="bto-sb-event-wrap">
                        <span class="bto-sb-event-team">
                          <span class="bto-sb-event-home">{{player.firstName}} {{player.lastName}}</span>
                        </span>
                                            </div>
                                            <div class="bto-sb-event-description">{{player.teamName}}</div>
                                        </a>
                                    </div>
                                </div>
                                <div class="bto-sb-event-odds-right">
                                    <div class="bto-sb-event-odds-cell">
                                        <match-odd-component
                                                :match="match"
                                                :odd="{
                        marketName: player.firstName,
                        competitorId: player.competitorId
                      }"
                                                :outcome="{
                        id: `p-o-${match.matchId}-${player.competitorId}-${player.playerId}-${playerOddIds.first}`,
                        name: t('Mobile.FirstGoalScorer'),
                        originalDecimalOutcome: player.originalFirstGoalOdd,
                        playerOddId: playerOddIds.first,
                        playerId: player.playerId,
                        suspended: player.suspended
                      }"
                                        />
                                        <match-odd-component
                                                :match="match"
                                                :odd="{
                        marketName: player.firstName,
                        competitorId: player.competitorId
                      }"
                                                :outcome="{
                        id: `p-o-${match.matchId}-${player.competitorId}-${player.playerId}-${playerOddIds.any}`,
                        name: t('Mobile.AnyGoalScorer'),
                        originalDecimalOutcome: player.originalAnyGoalOdd,
                        playerOddId: playerOddIds.any,
                        playerId: player.playerId,
                        suspended: player.suspended
                      }"
                                        />
                                        <match-odd-component
                                                :match="match"
                                                :odd="{
                        marketName: player.firstName,
                        competitorId: player.competitorId
                      }"
                                                :outcome="{
                        id: `p-o-${match.matchId}-${player.competitorId}-${player.playerId}-${playerOddIds.last}`,
                        name: t('Mobile.LastGoalscorer'),
                        originalDecimalOutcome: player.originalLastGoalOdd,
                        playerOddId: playerOddIds.last,
                        playerId: player.playerId,
                        suspended: player.suspended
                      }"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end - player odds 'all' view tab -->   
                    <!-- end - render tabs + markets -->
                </div>
            </div>
        </div>
        <div v-else-if="matchType === 'live' && hasLiveStream()" class="bto-sb-widget bto-sb-widget-prematch bto-sb-widget-prematch-full-view">
          <div class="bto-sb-widget">
            <livestream-component v-if="hasLiveStream() && !livePlayerFailed"
              :streamId="match.streamId || lcoMatch.streamId"
              :key="match.streamId || lcoMatch.streamId"
              :providerId="match.brokerId || lcoMatch.integrationBrokerId"
              @streamLoadError="livePlayerLoadError" />
            <inline-message v-if="livePlayerFailed" type="info" :message="t('Mobile.LiveStreamFailed')"/>
          </div>
        </div>
        <div v-else class="bto-sb-widget-content">
          <empty-state :message="emptyStateStatusMessage"  :icon-class="emptyStateClass" />
        </div>
    </div>
</template>

<script>
  import store from '../../../store';
  import OutrightsTabMarket from './common/outrights-tab-market';
  /* eslint-disable no-useless-return */
  import LiveTrackerComponent from '../../common/match/live-tracker-component';
  import LivestreamComponent from '../../common/match/livestream-component';
  import BaseMatchDetails from '../../shared/match-details/base';
  import { ICON_CLASS } from '../../shared/empty-state';
  import { EventBus } from '../../../services/event-bus-service';
  import PlayerMarketsComponent from './common/component-player-markets.vue';
  import BoostedOddWidget from '@bto-widgets/boosted-odd/src/web';
  import EventSelect from './event-select.vue';
  import { TournamentMatchesListRequestService } from '../sports-category/service-tournament-matches-request';
  import TournamentModel  from '../../../models/model-tournament';
  import PrematchTrackerComponent from '../../common/match/prematch-tracker-component';
  import ZoomSoccerComponent from '../../common/match/zoom-soccer-component';
  import { ZOOM_SOCCER_ID } from 'bto-models/match/zoom';

  export default {
    name: 'MatchDetailsWidget',
    extends: BaseMatchDetails,
    data() {
      return {
        columns: 1,
        selectedPlayer: undefined,
        selectedPlayerOddType: undefined,
        livePlayerFailed: false,
        playerOddsViewType: 'all', // ['dropdowns', 'all']
        selectedScorecastTabIdx: 0,
        selectedScorecastPlayerIdx: undefined,
        selectedScorecastPlayerOutcomeIdx: undefined,
        playerOddIds: {
          first: APP_SETTINGS.playerOdds.first,
          any: APP_SETTINGS.playerOdds.any,
          last: APP_SETTINGS.playerOdds.last,
        },
        canViewLiveStream: APP_SETTINGS.settings.canViewLiveStreamNoBalance,
        cashoutEnabledTab: APP_SETTINGS.settings.showCashoutTabInMatchDetails,
        useLiveTracker: APP_SETTINGS.liveTracker ? APP_SETTINGS.liveTracker.useLiveTracker : false,
        loadingSpinner: ICON_CLASS.LOADING,
        showTeamIcon: APP_SETTINGS.matchDetails.showTeamIcon,
        changeEvent: APP_SETTINGS.matchDetails.changeEvent,
        openEvent: false,
        prevCategoryId: 0,
        preMatchEvents: [],
        showLegendBar: APP_SETTINGS.matchDetails.showLegendBar,
        showStatistics: APP_SETTINGS.category.showStatistics,
        zoomSoccerId: ZOOM_SOCCER_ID,
        selectedTooltip: null,
        eventListenersForTooltipsSet: false,
      };
    },
    computed: {
      cashoutEnabledDB() {
        return store.getters.getCashoutDbSetting;
      },
      emptyStateClass() {
        return this.loading ? this.loadingSpinner : this.EMPTY_STATE_ICON;
      },
      emptyStateStatusMessage() {
        return this.loading ? this.t('Mobile.LoadingMore') : this.t('W.EmptyMatchDetails');
      },
      numOfMarketsToSlice() {
        return this.outrightsMarketId === -10 ? 3 : 2;
      },
      distinctPlayers() {
        return this.playerOdds
          .map(player =>
            player.lastName ? `${player.firstName} ${player.lastName}` : player.firstName
          )
          .sort()
          .filter((player, idx, self) => !idx || player !== self[idx - 1]);
      },
      cashoutEnabledUser() {
        return store.state.playerInfoModule.playerInfo.cashout;
      },
      showCashoutTab() {
        return this.cashoutEnabledDB && this.cashoutEnabledTab &&
          (!APP_SETTINGS.player.token || this.cashoutEnabledUser);
      },
      hasCashoutOdds() {
        return this.match.tabs && this.match.tabs.find(t => t.odds.find(o => o.cashout === true));
      },
      lcoMatch() {
        const routeMid = this.$route.params.matchId && `${this.$route.params.matchId}`;
        if (routeMid && routeMid.startsWith('eeid:')) {
          const eeid = routeMid.replace('eeid:', '');
          return store.getters.getExternalLiveStreamingMatch(eeid);
        }
        return store.getters.getInternalLiveStreamingMatch(this.getMatchId());
      },
      hasBetBuilderMarkets() {
        return Object.keys(this.betBuilderTabs).length > 0
      },
      hasSwishBetBuilderMarkets() {
        return Object.keys(this.swishBetBuilderTabs).length > 0;
      },
      hasBetBuilder() {
        return this.sportCastFixtureId || this.swishFixtureId;
      },
      isPlayerTabVisible() {
        return (this.playerTab.groups && this.playerTab.groups.length) || 
               (this.match.playerMarketsTab && this.match.playerMarketsTab.groups && this.match.playerMarketsTab.groups.length);
      }
    },
    components: {
      LiveTrackerComponent,
      OutrightsTabMarket,
      LivestreamComponent,
      PlayerMarketsComponent,
      BoostedOddWidget,
      EventSelect,
      PrematchTrackerComponent,
      ZoomSoccerComponent,
    },
    props: {
      liveTrackerForceEnabled: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    watch: {
      '$route.params': function () {
        this.reset();
        this.openEvent = false;
      },
      match: {
        handler(val) {
          if (!this.changeEvent) {
            return;
          }
          if (val.isLiveMatch) {
            this.preMatchEvents = [];
            this.prevCategoryId = 0;
            return; 
          }
          // Use this to get immediate results on page load/match change
          // if ((this.changeEvent && val.categoryId) && (this.prevCategoryId !== val.categoryId)) {
          //   this.getPrematchEvents(val);
          // }
        },
        immediate: true,
        deep: true,
      },
      selectedMarket(newVal, oldVal) {
        if (!newVal || (newVal !== oldVal)) {
          this.selectedTooltip = null;
        }
      },
    },
    mounted() {
      if (this.$route.name === 'seoGame' && !this.matchIdProp) {
        if (!window.btoSignalRAvailibility) {
          EventBus.$once('newLiveMatch', this.updateMatchDetails);
        }
        this.updateMatchDetails();
      }
    },
    methods: {
      getPrematchEvents(match) {
        let tournamentMatches = new TournamentMatchesListRequestService();
        // tournamentMatches.getParams.TournamentData = [match.tournamentId];
        tournamentMatches.getParams.CategoryData = [match.categoryId];
        this.prevCategoryId = match.categoryId;
        this.preMatchEvents = [];
        tournamentMatches.execute((resp) => {
          if (resp.data[0]) {
            this.preMatchEvents = resp.data[0].t.flatMap(t => new TournamentModel(t, resp.data[0].id, resp.data[0].is3way).matches);
          }
        });
      },
      /**
       * Check if the match is availlable for live streaming
       */
      hasLiveStream() {
        if (APP_SETTINGS.settings.disableVideoStream) {
          return false;
        }
        let userHasPermission = true;
        if (!this.canViewLiveStream) {
          const balance = this.getCookie('bto_balance');
          userHasPermission = balance && Number.parseFloat(balance) > 0;
        }
        const hasLiveStream = this.match.hasLiveStream || this.lcoMatch.streamId;
        return hasLiveStream && userHasPermission;
      },
      /**
       * Get cookie by cookie name
       */
      getCookie(cookieName = '') {
        if (document.cookie.length > 0) {
          var cookieStart = document.cookie.indexOf(cookieName + "=");
          if (cookieStart !== -1) {
            cookieStart = cookieStart + cookieName.length + 1;
            var cookieEnd = document.cookie.indexOf(";", cookieStart);
            if (cookieEnd === -1) {
              cookieEnd = document.cookie.length;
            }
            return decodeURI(document.cookie.substring(cookieStart, cookieEnd));
          }
        }
        return "";
      },
      /**
       * Common methods
       */
      selectedMarketInDropdown() {
        if (this.selectedMarket === this.BB_TAB_ID) {
          return false;
        }
        return !this.match.tabs ?
          undefined :
          this.match.tabs
            .slice(this.numOfMarketsToSlice).filter(tab => tab.id !== this.outrightsMarketId).map(tab => tab.id)
            .indexOf(this.selectedMarket) !== -1
          ||
          ['playerOdds', 'scorecast', 'cashout'].includes(this.selectedMarket);
      },
      changeView(columns) {
        this.columns = columns;
      },
      getViewClass() {
        if (this.columns === 1) {
          return 'bto-sb-event-mormarket-full';
        }

        if (this.columns === 2) {
          return 'bto-sb-event-mormarket-grid';
        }

        return '';
      },
      capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      livePlayerLoadError() {
        this.livePlayerFailed = true;
      },
      selectScorecastTab(idx) {
        if (this.selectedScorecastTabIdx === idx) {
          return;
        }

        this.selectedScorecastTabIdx = idx;
        this.selectedScorecastPlayerIdx = undefined;
      },
      scorecastPlayerUpdated() {
        this.selectedScorecastPlayerOutcomeIdx = undefined;
      },
      /**
       * Prematch methods
       */
      getSelectedPlayerOdd() {
        let playerOdd = this.playerOdds
          .find(player =>
            player.firstName === this.selectedPlayer
            ||
            `${player.firstName} ${player.lastName}` === this.selectedPlayer
          );

        if (!playerOdd) {
          return {};
        }

        let type = this.selectedPlayerOddType;

        return {
          name: this.t(`Mobile.${this.capitalize(type)}GoalScorer`),
          originalDecimalOutcome: playerOdd[`original${this.capitalize(type)}GoalOdd`],
        };
      },
      // used when match details is expanded on home widgets
      closeEmbededDetails() {
        this.$emit('toggleDetails');
        if (typeof this.$parent.toggleDetails !== 'undefined') {
          this.$parent.toggleDetails();
        }
      },
      openChangeEvents() {
        this.openEvent = !this.openEvent;
        // Use this to get lazy results on first event select expand
        if ((this.changeEvent && this.match.categoryId) && (this.prevCategoryId !== this.match.categoryId)) {
          this.getPrematchEvents(this.match);
        }
      },
      isItDuplicateMarket(odd, tabIndex) {
        if (this.matchTypeProp === "live" || (this.selectedMarket !== null && this.selectedMarket !== "cashout") || tabIndex === 0) {
          return false;
        }
        const idsForCheck = [...this.match.tabs].splice(0, tabIndex)
          .reduce((acc, val) => acc.concat([...val.odds]),[])
          .map(x => ({ [x.marketId]: x.extraId }));
        for (const id of idsForCheck) {
          const key = Object.keys(id);
          if (+key[0] === odd.marketId) {
            const value = Object.values(id)
            return value[0] === odd.extraId;
          }
        }
        return false;
      },
      toggleMarketTooltip(marketId) {
        if (this.selectedTooltip !== marketId) {
          this.selectedTooltip = marketId;
          if (!this.eventListenersForTooltipsSet) {
            document.getElementsByClassName("bto-sb-widget-betslip")[0].addEventListener("click", this.closeMarketTooltip);
            this.eventListenersForTooltipsSet = true;
          }
          return;
        }
        if (this.selectedTooltip === marketId) {
          this.closeMarketTooltip();
        }
      },
      closeMarketTooltip() {
        this.selectedTooltip = null;
      },
    },
    created() {
      EventBus.$on("closeTooltip", () => this.selectedTooltip = null);
    },
    beforeDestroy() {
      document.getElementsByClassName("bto-sb-widget-betslip")[0].removeEventListener("click", this.closeMarketTooltip);
    },
  };
</script>
